<template>
  <div>
    <van-action-sheet v-model="thatShow" title="切换店铺主页" @close="close">
      <div>
        <div :class="_['sheet-content']">
          <van-radio-group v-model="chooseId" @change="change">
            <div
              v-for="(store, index) in list"
              :key="index"
              :class="_['check-item']"
              @click="chooseId = store.merchantId"
            >
              <span :class="_['check-item-txt']">{{ store.merchantName }}</span>

              <van-radio
                :name="store.merchantId"
                checked-color="#ee0a24"
              ></van-radio>
            </div>
          </van-radio-group>
        </div>
        <div
          v-track="{
            name: '切换',
            id: 'cl9gtl4920004csugbxgidu50',
          }"
          :class="[_['sheet-bottom'], _._hairlineTop]"
        >
          <van-button
            round
            color="linear-gradient(to right, #ff6034, #ee0a24)"
            block
            :disabled="list.length == 0"
            @click="confirmChoose"
            >确定</van-button
          >
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
  //店铺选者弹框组件
  //参数：
  import Vue from 'vue'
  export default Vue.extend({
    props: {
      show: {
        type: Boolean,
        default: false,
      },
      list: {
        type: Array,
        default: () => {
          return []
        },
      },
      choosed: {
        type: Object,
        default: () => {
          return {}
        },
      },
    },
    data() {
      return {
        chooseStore: {
          // defaultChoose: true, //是否默认选中
          // // logo: icon.headImg, //logo图片
          // merchantId: 'ahd11233', //店铺Id
          // merchantName: '贵州蔬菜研究基地有限责任公司', //店铺名称
          // notice: '新店开业，欢迎您的光临，本店服务至上的如果您新…', //公告
        },
        chooseId: '',
        thatShow: true,
      }
    },
    computed: {
      loading() {
        return false
      },
    },
    watch: {
      show: {
        immediate: true,
        handler(newValue) {
          this.thatShow = newValue
        },
      },
      choosed: {
        handler(newValue) {
          this.chooseStore = newValue
          this.chooseId = newValue.merchantId
        },
        deep: true,
      },
    },
    methods: {
      close(val) {
        this.thatShow = false
        this.$emit('closeEmit', val)
      },
      confirmChoose() {
        this.close(this.chooseStore)
      },
      change(val) {
        const choose = this.list.filter(item => {
          return item.merchantId === val
        })
        this.chooseId = val
        this.chooseStore = choose[0]
      },
    },
  })
</script>

<style lang="scss" module>
  .sheet-content {
    max-height: 300px;
    overflow: scroll;
    padding: 20px 14px 40px 11px;
    font-size: 14px;
    .check-item {
      width: 100%;
      padding: 17px 0 17px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .check-item-txt {
        width: 308px;
      }
    }
  }
  .sheet-bottom {
    width: calc(100% - 24px);
    height: 60px;
    display: flex;
    align-items: center;
    padding: 0 12px;
  }
</style>
